import { Navigate, useLocation, useParams } from 'react-router-dom';

// Both historical set paths resolve to the query selection consumed by the
// collection screen. The path id is authoritative over a conflicting query id.
export function CollectionSetLegacyRedirect() {
  const { caseKey, setId } = useParams<{ caseKey: string; setId: string }>();
  const location = useLocation();
  if (!caseKey || !setId) return <Navigate to="/cases" replace />;

  const search = new URLSearchParams(location.search);
  search.set('set', setId);
  return (
    <Navigate
      replace
      to={{
        pathname: `/cases/${encodeURIComponent(caseKey)}/collection`,
        search: `?${search.toString()}`,
        hash: location.hash,
      }}
    />
  );
}
